"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Async = void 0;
const typings = __importStar(require("@monorepo/typings/sdk"));
class Async {
    sdk;
    api;
    session;
    mount;
    constructor(sdk) {
        this.sdk = sdk;
        this.api = sdk.api;
        this.session = sdk.session;
        this.mount = sdk.mount;
    }
    signInAndWait = (hex) => this.api.awaitRequest({
        command: typings.COMMANDS.SIGN,
        data: {
            tx: { TransactionType: 'SignIn' },
            hex,
        },
    });
    signAndWait = (tx, opts) => this.api.awaitRequest({
        command: typings.COMMANDS.SIGN,
        data: {
            tx,
            opts,
        },
    });
    submitAndWait = (address, txblob, opts) => this.api.awaitRequest({
        command: typings.COMMANDS.SUBMIT,
        data: {
            address,
            txblob,
            opts,
        },
    });
    signAndSubmitAndWait = (tx, opts) => this.api.awaitRequest({
        command: typings.COMMANDS.SIGNANDSUBMIT,
        data: {
            tx,
            opts,
        },
    });
    bulkSignAndWait = (txns, opts) => this.api.awaitRequest({
        command: typings.COMMANDS.BULKSIGN,
        data: {
            txns,
            opts,
        },
    });
    bulkSubmitAndWait = (address, txblobs, opts) => this.api.awaitRequest({
        command: typings.COMMANDS.BULKSUBMIT,
        data: {
            address,
            txblobs,
            opts,
        },
    });
    bulkSignAndSubmitAndWait = (txns, opts) => this.api.awaitRequest({
        command: typings.COMMANDS.BULK,
        data: {
            txns,
            opts,
        },
    });
    encryptAndWait = {
        aes: (address, data, opts) => this.api.awaitRequest({
            command: typings.COMMANDS.ENCRYPT,
            data: {
                address,
                data,
                opts,
            },
        }),
    };
    decryptAndAwait = {
        aes: (address, hex, opts) => this.api.awaitRequest({
            command: typings.COMMANDS.DECRYPT,
            data: {
                address,
                hex,
                opts,
            },
        }),
    };
    isLockedAndWait = () => this.api.awaitRequest({
        command: typings.COMMANDS.IS_LOCKED,
    });
    versionAndWait = () => this.api.awaitRequest({
        command: typings.COMMANDS.VERSION,
    });
    verifyAndWait = (hex) => this.api.awaitRequest({
        command: typings.COMMANDS.VERIFY,
        data: {
            hex,
        },
    });
    connect = (timeout) => this.mount.loop(timeout);
    detect = (timeout) => this.mount.loop(timeout);
}
exports.Async = Async;
